
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    name: 'VariantSelectorImageButton',
})
export default class VariantSelectorImageButton extends Vue {
    @Prop() private code: any;
    @Prop() private label: any;
    @Prop() private selected: any;
    @Prop() private image: any;
    @Prop() private expanded: boolean;

    get backgroundImage(): string {
        if (this.image) {
            return `background-image: url('${ this.image }')`;
        } else {
            return `background: #fafafa`;
        }
}
}
